module.exports = __webpack_public_path__ + "static/media/Lock.dfc002d0.svg";